import { ProgramType } from './ProgramTypes';

export const monthlyPaymentCapProgramTypes: ProgramType[] = [
  ProgramType.solar,
  ProgramType.hvac,
  ProgramType.waterHeater,
  ProgramType.geothermal,
  ProgramType.consumerSolar,
];

export enum AdjustMonthlyPaymentCapTypes {
  overridePaymentCaps = 'overridePaymentCaps',
  updatePaymentCaps = 'updatePaymentCaps',
}
